import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
  Checkbox,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { openFileUrl } from "../utils/openReport";

const ReportAccountPayableInsurer = ({}) => {
  const [loading, setLoading] = useState(false);
  const [onlyPaid, setOnlyPaid] = useState(true);
  const [fromDate, setFromDate] = useState(() =>
    moment().startOf("month").toDate()
  );
  const [toDate, setToDate] = useState(() => moment().endOf("month").toDate());
  // const [dateType, setDateType] = useState("submissionDate");

  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);

      // console.log(fromDate, toDate);
      const result = await api.DebitNote.getAccountPayableInsurerReport({
        fromDate,
        toDate,
        onlyPaid,
      });
      setLoading(false);
      // console.log(result);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t(
          "Please click the below button to download the account payable to insurer report."
        )}
      </Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          value={fromDate}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          value={toDate}
          onChange={(d) => setToDate(d)}
        />
        <Checkbox
          size="xs"
          label={t("Only show PAID payment status")}
          checked={onlyPaid}
          onChange={(e) => setOnlyPaid(e.currentTarget.checked)}
        />
        {/* <Select
          size="xs"
          defaultValue={"submissionDate"}
          data={DATA_REPORT_DATE_TYPE}
          onChange={(type) => setDateType(type)}
        /> */}
      </Group>

      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportAccountPayableInsurer;
